import { useMutation, useQuery } from "@tanstack/react-query";
import { ActivityLog, clearActivityLog } from "api/activityLog";
import AlertNotification from "components/CustomWidgets/alertNotification";

export const useActivityLog = (
  { page, limit, filter, see_all },
  options = {},
) => {
  return useQuery({
    queryKey: ["activity_log", { page, limit, filter, see_all }],
    queryFn: ActivityLog,
    ...options,
  });
};

export const useClearActivityLog = (options = {}) => {
  return useMutation({
    mutationFn: clearActivityLog,
    onSuccess: (data, variables, context) => {
      AlertNotification(
        "success",
        data.message || "Activity log cleared successfully",
      );

      options.onSuccess?.(data, variables, context);
    },
  });
};
